import { createSlice } from "@reduxjs/toolkit";
const textChangeSlice = createSlice({
  name: "textChange",
  initialState: {},
  reducers: {
    textChange(state, action) {
      state.value = action.payload;
    },
    resetText(state, action) {
      state.value = null;
    },
  },
});
export { textChangeSlice };
export const { textChange, resetText } = textChangeSlice.actions;
